import FAQ from './FAQ';
export default FAQ;
export { default as FAQAccordionList } from './FAQAccordionList';
export type { FaqEntry, FAQAccordionListProps } from './types';
